import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getACustomDesign,
} from "../features/customDesign/customDesignSlice";
import { BiArrowBack } from "react-icons/bi";

const ViewCustomDesign = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getDesignId = location.pathname.split("/")[3];
  const designState = useSelector((state) => state.customDesign);
  const { designName, designMobile, designEmail, designRemarks, designStatus, designImages } = designState;

  useEffect(() => {
    dispatch(getACustomDesign(getDesignId));
  }, [getDesignId, dispatch]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Custom Design Enquiry</h3>
        <button
          className="bg-transparent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
        </button>
      </div>
      <div className="mt-5 bg-white p-4 d-flex gap-3 flex-column rounded-3">
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Name:</h6>
          <p className="mb-0">{designName}</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Mobile:</h6>
          <p className="mb-0">
            <a href={`tel:+91${designMobile}`}>{designMobile}</a>
          </p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Email:</h6>
          <p className="mb-0">
            <a href={`mailto:${designEmail}`}>{designEmail}</a>
          </p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Remarks / Additional Notes:</h6>
          <p className="mb-0">{designRemarks || "N/A"}</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Status:</h6>
          <p className="mb-0">{designStatus}</p>
        </div>
        
        <div className="d-flex flex-column gap-2 mt-3">
          <h6 className="mb-0">Uploaded Designs:</h6>
          {designImages && designImages.length > 0 ? (
            <div className="d-flex gap-3 flex-wrap mt-2">
              {designImages.map((imgUrl, i) => (
                <div key={i} className="border p-2 rounded" style={{ maxWidth: "300px" }}>
                  <a href={imgUrl} target="_blank" rel="noopener noreferrer">
                    <img 
                      src={imgUrl} 
                      alt={`Design ${i+1}`} 
                      className="img-fluid rounded" 
                      style={{ maxHeight: "250px", objectFit: "contain" }}
                    />
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted mb-0">No designs uploaded.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewCustomDesign;
